import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { ImageLoader } from '../../../../ui/loaders/ImageLoader/index.js';
import Additional from './Additional/index.js';
import styles from './index.module.scss.js';

const GameSkinV2 = ({
  id,
  href = "/",
  title,
  subtitle,
  size = "MD",
  type,
  customizedLayers,
  imageLayers,
  additionalInfo,
  index,
  showPlaceholder,
  optimizedSrc,
  className,
  style,
  skeleton,
  ...props
}) => /* @__PURE__ */ React.createElement(
  Link,
  {
    className: `${cx(styles.box, "game-card", {
      [styles[type || ""]]: !!type,
      [styles[size || ""]]: !!size
    })} ${className}`,
    to: href,
    "data-game-type": type,
    key: index,
    style: {
      ...style
    },
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, /* @__PURE__ */ React.createElement("div", { className: styles.media }, /* @__PURE__ */ React.createElement("div", { className: styles.media__wrapper }, /* @__PURE__ */ React.createElement("div", { className: styles.media__img }, /* @__PURE__ */ React.createElement(
    ImageLoader,
    {
      src: imageLayers?.mediaImage || "",
      alt: title,
      showPlaceholder,
      optimizedSrc,
      skeleton
    }
  ))))),
  additionalInfo && /* @__PURE__ */ React.createElement(Additional, { ...additionalInfo, v2: type === "GAME_V2_SMALL" })
);

export { GameSkinV2 as default };
//# sourceMappingURL=index.js.map
